<template>
  <div class="container">
    <MenuNavbar :taboption="taboption" />

    <TableBasic :payload="payload" />
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import MenuNavbar from "@/components/global/MenuNavbar.vue";
export default {
  components: {
    TableBasic,
    MenuNavbar,
  },
  data() {
    return {
      taboption: [
        {
          name: "All",
          component: "",
          payload: {},
        },
        {
          name: "Published",
          component: "",
          payload: {},
        },
        {
          name: "Pending",
          component: "",
          payload: {},
        },
        {
          name: "Scheduled",
          component: "",
          payload: {},
        },
        {
          name: "Draft",
          component: "",
          payload: {},
        },
        {
          name: "Trash",
          component: "",
          payload: {},
        },
      ],
      payload: {
        header: [
          {
            key: "title",
            label: "Title",
            class: "text-center",
          },
          {
            key: "content",
            label: "Content",
            class: "text-center",
          },
          {
            key: "sent_to",
            label: "Sent To",
            class: "text-center",
          },
          {
            key: "status",
            label: "Status",
            class: "text-center",
          },
          {
            key: "date",
            label: "Date",
            class: "text-center",
          },
          {
            key: "actions",
            label: "Actions",
            class: "text-center",
          },
        ],
        value: [
          {
            title: "DAPETIN PROMO AWAL TAHUN",
            content: "TOP UP CREDIT",
            sent_to: "All User",
            status: "Published",
            date: "30 Januari 2022",
            actions: "",
          },
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
    };
  },
};
</script>

<style></style>
